/**
 *
 * @param {File} image
 * @returns an object with the dimensions of `image`
 */
async function getImageDimensions(image) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = window.URL.createObjectURL(image);
  });
}

/**
 *
 * @param {Image} image The image to be validated
 * @param {Number} width The width that the `image` must be
 * @param {Number} height The height that the `image` must be
 * @returns a boolean indicating if the `image` has valid dimensions
 */
async function validateImageDimensions(image, width, height) {
  const imageDimensions = await getImageDimensions(image);
  const isValid =
    imageDimensions.width === +width && imageDimensions.height === +height;

  return isValid;
}

/**
 * Tipos aceitos como imagem de projeto, iguais aos do `filterImage` da API.
 *
 * O `accept` do <input> só filtra o que o seletor mostra — o usuário troca
 * para "todos os arquivos" e escolhe o que quiser. Por isso a checagem se
 * repete aqui, para o erro aparecer antes do upload em vez de voltar 415.
 */
const ACCEPTED_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg'];
const ACCEPTED_IMAGE_MIMETYPES = ['image/png', 'image/jpeg'];

/** Valor pronto para o atributo `accept` de um <input type="file">. */
const IMAGE_ACCEPT = ACCEPTED_IMAGE_MIMETYPES.join(',');

function isAcceptedImage(file) {
  const name = (file.name || '').toLowerCase();
  const hasExtension = ACCEPTED_IMAGE_EXTENSIONS.some(ext =>
    name.endsWith(ext)
  );

  return (
    hasExtension &&
    ACCEPTED_IMAGE_MIMETYPES.includes((file.type || '').toLowerCase())
  );
}

export {
  getImageDimensions,
  validateImageDimensions,
  isAcceptedImage,
  IMAGE_ACCEPT,
};
